import { authenticationsCheckSession } from '../redux/actions/authentications';
import { idCompany4Case } from './defaultPermissions';
import {
  reportSchemasModifyStore,
  removeReportSchemasOnly
} from '../redux/actions/reportSchemas';
import {
  departmentsModifyStore,
  removeDepartmentsSuccess
} from '../redux/actions/departments';
import { pabxsModifyStore, removePABXsSuccess } from '../redux/actions/pabxs';
import {
  networksGroupModifyStore,
  removeNetworksGroupSuccess
} from '../redux/actions/networksGroup';
import {
  devicesModifyStore,
  removeDevicesSuccess
} from '../redux/actions/devices';
import {
  statusModifyStore,
  removeStatusSuccess
} from '../redux/actions/status';
import {
  expedientsModifyStore,
  removeExpedientsSuccess
} from '../redux/actions/expedients';
import { ivrsModifyStore, removeIVRsSuccess } from '../redux/actions/ivrs';
import { usersModifyStore, removeUsersSuccess } from '../redux/actions/users';
import {
  categoriesModifyStore,
  removeCategoriesSuccess
} from '../redux/actions/categories';
import {
  manufacturersModifyStore,
  removeManufacturersSuccess
} from '../redux/actions/manufacturers';
import {
  productsModifyStore,
  removeProductsSuccess
} from '../redux/actions/products';
import {
  servicesModifyStore,
  removeServicesSuccess
} from '../redux/actions/services';
import {
  speciesModifyStore,
  removeSpeciesSuccess
} from '../redux/actions/species';
import { petsModifyStore, removePetsSuccess } from '../redux/actions/pets';
import {
  breedsModifyStore,
  removeBreedsSuccess
} from '../redux/actions/breeds';
import {
  veterinariansModifyStore,
  removeVeterinariansSuccess
} from '../redux/actions/veterinarians';
import {
  schedulesModifyStore,
  removeSchedulesSuccess
} from '../redux/actions/schedules';
import {
  clientsModifyStore,
  removeClientsSuccess
} from '../redux/actions/clients';
import {
  occurrencesModifyStore,
  removeOccurrencesSuccess
} from '../redux/actions/occurrences';
import {
  typeSchedulesModifyStore,
  removeTypeSchedulesSuccess
} from '../redux/actions/typeSchedules';
import {
  typeOccurrencesModifyStore,
  removeTypeOccurrencesSuccess
} from '../redux/actions/typeOccurrences';
import {
  vaccinesModifyStore,
  removeVaccinesSuccess
} from '../redux/actions/vaccines';
import {
  codesNCMModifyStore,
  removeCodesNCMSuccess
} from '../redux/actions/codesNCM';
import {
  permissionsGroupModifyStore,
  removePermissionsGroupSuccess
} from '../redux/actions/permissionsGroup';
import {
  companiesModifyStore,
  removeCompaniesSuccess
} from '../redux/actions/companies';
import {
  suppliersModifyStore,
  removeSuppliersSuccess
} from '../redux/actions/suppliers';

const ModifyStore = dispatch => {
  return response => {
    try {
      const { type, module, data, token } = response;
      const sessionToken = localStorage.getItem('token');
      const sessionUser = JSON.parse(localStorage.getItem('user'));
      const companyId = sessionUser.company._id;
      switch (module) {
        // CallCenter
        case 'reportSchemas': {
          if (sessionToken === token) {
            if (['ADD', 'EDIT'].includes(type)) {
              dispatch(reportSchemasModifyStore(response));
            } else if (['REMOVE'].includes(type)) {
              dispatch(removeReportSchemasOnly(data));
            }
          }
          break;
        }
        case 'departments': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(
              item =>
                sessionUser.departments.includes(item._id) ||
                sessionUser.departments.includes(item.macroDepartment._id)
            );
            if (data && data.length) {
              dispatch(departmentsModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeDepartmentsSuccess(data));
          }
          break;
        }
        case 'pabxs': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(pabxsModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removePABXsSuccess(data));
          }
          break;
        }
        case 'networksGroup': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(networksGroupModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeNetworksGroupSuccess(data));
          }
          break;
        }
        case 'devices': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(devicesModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeDevicesSuccess(data));
          }
          break;
        }
        case 'status': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(statusModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeStatusSuccess(data));
          }
          break;
        }
        case 'expedients': {
          if (['ADD', 'EDIT'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(expedientsModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeExpedientsSuccess(data));
          }
          break;
        }
        case 'ivrs': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(ivrsModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeIVRsSuccess(data));
          }
          break;
        }
        case 'users': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const data = response.data.filter(item =>
              sessionUser.departments.includes(item.department._id)
            );
            if (data && data.length) {
              dispatch(usersModifyStore({ ...response, data }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeUsersSuccess(data));
          }
          break;
        }
        // PetShop
        case 'categories': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(categoriesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeCategoriesSuccess(data));
          }
          break;
        }
        case 'manufacturers': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(manufacturersModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeManufacturersSuccess(data));
          }
          break;
        }
        case 'products': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(productsModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeProductsSuccess(data));
          }
          break;
        }
        case 'services': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(servicesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeServicesSuccess(data));
          }
          break;
        }
        case 'species': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(speciesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeSpeciesSuccess(data));
          }
          break;
        }
        case 'pets': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(petsModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removePetsSuccess(data));
          }
          break;
        }
        case 'breeds': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(breedsModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeBreedsSuccess(data));
          }
          break;
        }
        case 'veterinarians': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(veterinariansModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeVeterinariansSuccess(data));
          }
          break;
        }
        case 'schedules': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(schedulesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeSchedulesSuccess(data));
          }
          break;
        }
        case 'clients': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(clientsModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeClientsSuccess(data));
          }
          break;
        }
        case 'occurrences': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(occurrencesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeOccurrencesSuccess(data));
          }
          break;
        }
        case 'typeSchedules': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(typeSchedulesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeTypeSchedulesSuccess(data));
          }
          break;
        }
        case 'typeOccurrences': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(typeOccurrencesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeTypeOccurrencesSuccess(data));
          }
          break;
        }
        case 'vaccines': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { company } = response;
            if (company === companyId) {
              dispatch(vaccinesModifyStore(response));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeVaccinesSuccess(data));
          }
          break;
        }
        case 'codesNCM': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            dispatch(codesNCMModifyStore(response));
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeCodesNCMSuccess(data));
          }
          break;
        }
        case 'suppliers': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            dispatch(suppliersModifyStore(response));
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeSuppliersSuccess(data));
          }
          break;
        }
        case 'permissionsGroup': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { data } = response;
            if (data && data.length) {
              const newData = data.filter(
                item => item.company._id === sessionUser.company._id
              );
              dispatch(
                permissionsGroupModifyStore({ ...response, data: newData })
              );
              const permissionsGroup = data.find(
                item => item._id === sessionUser.permissionsGroup._id
              );
              if (permissionsGroup) {
                dispatch(
                  authenticationsCheckSession({
                    ...sessionUser,
                    permissionsGroup
                  })
                );
              }
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removePermissionsGroupSuccess(data));
          }
          break;
        }
        case 'companies': {
          if (['ADD', 'EDIT', 'RESTORE'].includes(type)) {
            const { data } = response;
            if (data && data.length) {
              const newData = data.filter(
                item =>
                  item._id === sessionUser.company._id ||
                  sessionUser.company._id === idCompany4Case
              );
              dispatch(companiesModifyStore({ ...response, data: newData }));
            }
          } else if (['REMOVE'].includes(type)) {
            dispatch(removeCompaniesSuccess(data));
          }
          break;
        }
        default: {
          console.error('ModifyStore error module not found');
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export default ModifyStore;
